import TtamIos14InfoPolicyInfo from './policy-info/index.vue';
import TtamIos14InfoQuotaCard from './quota-card/index.vue';
import TtamIos14InfoQuotaDetailCampaign from './quota-detail-campaign/index.vue';
import TtamIos14InfoQuotaDetailAdgroup from './quota-detail-adgroup/index.vue';
import TtamIos14InfoQuotaDetailCreative from './quota-detail-creative/index.vue';
import TtamIos14InfoQuotaDetailSplitTest from './quota-detail-split-test/index.vue';
import TtamIos14InfoQuotaDetailLimit from './quota-detail-limit/index.vue';
import * as Hooks from './hooks';

export default {
  TtamIos14InfoPolicyInfo,
  TtamIos14InfoQuotaCard,
  TtamIos14InfoQuotaDetailCampaign,
  TtamIos14InfoQuotaDetailAdgroup,
  TtamIos14InfoQuotaDetailCreative,
  TtamIos14InfoQuotaDetailSplitTest,
  TtamIos14InfoQuotaDetailLimit,
  ...Hooks,
};
